import { createEntry, insertCss } from "@/helpers/entriesHelper";
import Summary from "@/views/Summary/Summary.vue";
createEntry(Summary, "eopoi-app-widget");
insertCss();
